let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bs5Nd")).then(() => parcelRequire('a7bIt'));